<div class="container-fluid shadow-none">
  <div class="d-flex border-top pt-5 mx-5">
    <div class="flex-column col-4 px-0">
      <h5 class="fw-bold pb-3">GRENS</h5>
      <ul>
        <li translate>{{ 'footer.who_we_are' }}</li>
        <li translate>{{ 'footer.find_job' }}</li>
        <li translate>{{ 'footer.find_professional_figure' }}</li>
      </ul>
    </div>
    <div class="flex-column col-4 px-0">
      <h5 class="fw-bold pb-3" translate>{{ 'footer.useful_info' }}</h5>
      <ul>
        <li translate>{{ 'footer.help' }}</li>
        <li translate>{{ 'footer.security' }}</li>
        <li translate>{{ 'footer.privacy' }}</li>
        <li translate>{{ 'footer.service_use' }}</li>
        <li translate>{{ 'footer.cookie_policy' }}</li>
        <li translate>{{ 'footer.cookie_management' }}</li>
      </ul>
    </div>
  </div>
  <div class="row footer-copyright d-flex flex-wrap align-items-center justify-content-between text-center mt-5 p-5">
    <p class="mb-0 f-w-600" translate>{{ "footer.company_data" }}</p>
  </div>
</div>
